module.exports = __webpack_public_path__ + "icon.0a23d077.svg";